import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MDash } from 'ui-components/components/mdash';

import { ReturnReasonService } from '../../../../../services/return-reason-service';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import messages from '../messages';

const ItemReturnReasonColumnId = 'returnReasonId';

const itemReturnReasonDataBuilder = (item) => {
  return item[ItemReturnReasonColumnId];
};

const ItemReturnReasonCell = ({ value }) => {
  return value ? ReturnReasonService.getReturnReasonText({ returnReasonId: value, name: value }) : <MDash />;
};

ItemReturnReasonCell.propTypes = {
  value: PropTypes.string,
};

const createItemReturnReasonColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.returnReason} />,
  accessor: ItemReturnReasonColumnId,
  Cell: ItemReturnReasonCell,
  width: 1,
});

export { ItemReturnReasonColumnId, itemReturnReasonDataBuilder, ItemReturnReasonCell, createItemReturnReasonColumnDefinition };
